// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { i18n } from '@lingui/core';
import { BookitupNotification } from '../../../../Types/LogT';

const ProcedureFailed: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { value } = notification;

  return (
    <Text>
      Die Workflow prozedur{'  '}
      <Text span weight="bolder">
        {i18n._(`actionType.${value}`)}
      </Text>
      {'  '} ist fehlgeschlagen.
    </Text>
  );
};

export default ProcedureFailed;
